import styles from './gallery.module.scss'
import LeftArrow from './assets/left_arrow.svg'
import RightArrow from './assets/right_arrow.svg'
import React from 'react'

type Props = {
  image: string
  alt: string
  handleNext: () => void
  handlePrevious: () => void
  isModal: boolean
  onClick?: () => void
}

export const MainImage: React.FC<Props> = ({
  image,
  alt,
  handleNext,
  handlePrevious,
  isModal,
  onClick,
}) => {
  return (
    <div
      className={`${styles.gallery__main_image} ${
        !handleNext ? styles.gallery__center_image : ''
      }`}>
      {handleNext && (
        <LeftArrow
          className={styles.gallery__arrow_left}
          onClick={handlePrevious}
        />
      )}
      <img
        src={image}
        alt={alt}
        className={`${styles.gallery__main_image_display} ${
          isModal ? styles.gallery__main_image_display_modal : ''
        }`}
        onClick={onClick}
      />
      {handleNext && (
        <RightArrow
          className={styles.gallery__arrow_right}
          onClick={handleNext}
        />
      )}
    </div>
  )
}
